<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    width="35%"
    @close="handleClose"
  >
    <template v-if="statusCode === 0">
      <el-form :model="form" :rules="rules" ref="forms" label-width="120px">
        <el-form-item
          :label="this.$t('center.email')"
          prop="email"
          v-if="type === 'email'"
        >
          <el-input
            v-model="form.email"
            :placeholder="this.$t('center.plaEmail')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('center.phone')"
          v-if="type === 'phone'"
          prop="phone"
        >
          <el-input
            v-model="form.phone"
            :placeholder="this.$t('center.plaPhone')"
          >
            <template slot="prepend">
              <el-select
                v-model="prefix"
                :placeholder="$t('common.select')"
                style="width:85px"
                @change="changeCountryCode"
              >
                <el-option
                  v-for="country in countryList"
                  :key="country.value"
                  :label="country.label"
                  :value="country.label"
                >
                  <span style="float: left">{{ country.key }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    country.label
                  }}</span>
                </el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="this.$t('center.code')" prop="code">
          <el-input v-model="form.code">
            <template slot="append">
              <el-button type="primary" @click="getEmailCode" v-if="!showTime"
                >{{ $t('center.getCode') }}
              </el-button>
              <span v-else>{{ timer }}{{ $t('center.reGetCode') }}</span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </template>
    <template v-else>
      <el-form :model="updateForm">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="this.$t('center.valPhone')"
            name="1"
            v-if="activeName === '1'"
          >
            <template v-if="userInfo.phone">
              <el-form
                :model="phoneForm"
                label-width="120px"
                ref="phoneForm"
                :rules="comRules"
              >
                <el-form-item :label="this.$t('center.phone')">
                  <el-input
                    v-model="userInfo.phone"
                    placeholder=""
                    :disabled="true"
                  >
                    <template slot="prepend">{{ userInfo.prefix }}</template>
                  </el-input>
                </el-form-item>
                <el-form-item :label="this.$t('center.code')" prop="code">
                  <el-input v-model="phoneForm.code">
                    <template slot="append">
                      <el-button
                        type="primary"
                        @click="getEmailCode"
                        v-if="!showTime"
                        >{{ $t('center.getCode') }}
                      </el-button>
                      <span v-else
                        >{{ timer }}{{ $t('center.reGetCode') }}</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
              </el-form>
            </template>
            <template v-else>
              <p style="text-align:center;padding: 20px;">
                {{ $t('center.noBindPhone') }}
              </p>
            </template>
          </el-tab-pane>
          <el-tab-pane
            :label="this.$t('center.valEmail')"
            name="2"
            v-if="activeName === '2'"
          >
            <template v-if="userInfo.email">
              <el-form
                :model="emailForm"
                label-width="120px"
                ref="emailForm"
                :rules="comRules"
              >
                <el-form-item :label="this.$t('center.email')">
                  <el-input
                    v-model="userInfo.email"
                    placeholder=""
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="this.$t('center.code')" prop="code">
                  <el-input v-model="emailForm.code">
                    <template slot="append">
                      <el-button
                        type="primary"
                        @click="getEmailCode"
                        v-if="!showTime"
                        >{{ $t('center.getCode') }}
                      </el-button>
                      <span v-else
                        >{{ timer }}{{ $t('center.reGetCode') }}</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
              </el-form>
            </template>
            <template v-else>
              <p style="text-align:center;padding: 20px;">
                {{ $t('center.noBindEmail') }}
              </p>
            </template>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </template>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{
        $t('common.confirm')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  getEmailCode,
  sendPhoneCode,
  comCheckCode
} from '@/services/userCenter.js'
import {
  validatorPhoneRule,
  validatorEmailRule
} from '@/utils/validatorRule.js'
import * as companyApi from '@/services/companyApi'
export default {
  name: 'ZkEmailAndPhone',
  data() {
    let checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('center.plaCode')))
      } else {
        return callback()
      }
    }
    let checkBind = (rule, value, callback) => {
      let type = value.includes('@') ? 1 : 2
      let params = {
        content: value,
        type
      }
      companyApi.checkBindPhoneOrEmail(params).then(data => {
        if (data.code === '00000000') {
          return callback()
        } else {
          if (value.includes('@')) {
            return callback(new Error(this.$t('common.alreadyBindEmail')))
          } else {
            return callback(new Error(this.$t('common.alreadyBindPhone')))
          }
        }
      })
    }
    return {
      prefix: '+86',
      countryList: [],

      form: {
        email: '',
        // phone: '',
        code: ''
      },
      // statusCode: this.status,
      updateForm: {},
      activeName: '1',
      rules: {
        email: validatorEmailRule(true, checkBind),
        phone: validatorPhoneRule(true, checkBind),
        code: [
          {
            required: true,
            message: this.$t('center.plaCode'),
            trigger: 'blur'
          }
        ]
      },
      timer: 60,
      showTime: false,
      emailForm: {
        code: ''
      },
      comRules: {
        code: [
          {
            required: true,
            validator: checkCode,
            // message: this.$t('center.plaCode'),
            trigger: 'blur'
          }
        ]
      },
      interval: null,
      isUpdateEmail: false,
      isUpdatePhone: false,
      phoneForm: {
        code: ''
      },
      isType: ''
    }
  },
  computed: {
    show: {
      set: function() {
        return this.showDialog
      },
      get: function() {
        return this.showDialog
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    status: {
      type: Number,
      default: 0
    },
    userInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
    results: {
      type: Object
    },
    active: {
      type: String
    }
  },
  watch: {
    status: {
      handler: function(val) {
        this.statusCode = val
      },
      immediate: true
    },
    title: {
      handler: function(val) {
        this.title = val
      }
    },
    active: {
      handler(val) {
        this.activeName = val
      },
      immediate: true
    }
  },
  mounted() {
    companyApi.loadCountry().then(data => {
      this.countryList = []
      let key = Object.keys(data)
      key.forEach(item => {
        this.countryList.push({
          key: this.$t('contry.' + item),
          value: item,
          label: '+' + data[item]
        })
      })
    })
  },
  methods: {
    changeCountryCode(value) {
      this.countryList.filter(item => {
        if (item.value === value) {
          this.prefix = item.label
          return ''
        }
      })
    },
    handleClick(tab, event) {
      if (tab.name === '1') {
        this.$emit('isType', 'phone') // 修改邮箱 身份验证选择手机
        this.isType = 'phone'
      } else if (tab.name === '2') {
        this.$emit('isType', 'email')
        this.isType = 'email'
      }
    },
    // 发送验证
    getEmailCode() {
      let _self = this
      // statusCode 0: 绑定操作
      if (_self.statusCode === 0) {
        if (_self.type === 'email') {
          // 校验code必填
          _self.$refs.forms.validateField('email', function(errorMessage) {
            if (errorMessage === '') {
              let params = {
                email: _self.form.email,
                type: 'bindEmail'
              }
              _self.getCode(params)
            }
          })
        } else {
          _self.$refs.forms.validateField('phone', function(errorMessage) {
            if (errorMessage === '') {
              let params = {
                phone: _self.form.phone,
                type: 'bindPhone',
                prefix: _self.prefix
              }
              _self.getCode(params)
            }
          })
        }
      } else {
        // statusCode 1:  修改操作
        let params = {}
        if (_self.type === 'email') {
          params = {
            email: _self.results.email, //   'ryan.lu@zkteco.com'
            type: 'checkEmail'
          }
        } else {
          params = {
            phone: _self.results.phone,
            type: 'checkPhone',
            prefix: _self.results.prefix
          }
        }
        _self.getCode(params)
      }
    },

    // 获取验证码 倒计时
    getCode(params) {
      let _self = this
      if (_self.type === 'email') {
        getEmailCode(params)
          .then(data => {
            _self.showTime = true
            if (data.code === '00000000') {
              _self.interval = setInterval(() => {
                if (_self.timer === 0) {
                  _self.timer = 60
                  _self.showTime = false
                  clearInterval(_self.interval)
                  return
                }
                _self.timer--
              }, 1000)
            } else {
              _self.$message.error(data.message)
            }
          })
          .catch(e => {})
      } else {
        sendPhoneCode(params)
          .then(data => {
            _self.showTime = true
            if (data.code === '00000000') {
              _self.interval = setInterval(() => {
                if (_self.timer === 0) {
                  _self.timer = 60
                  _self.showTime = false
                  clearInterval(_self.interval)
                  return
                }
                _self.timer--
              }, 1000)
            } else {
              _self.$message.error(data.message)
            }
          })
          .catch(e => {})
      }
    },

    handleClose() {
      this.form.code = ''
      this.form.email = ''
      this.form.phone = ''
      clearInterval(this.interval)
      this.interval = null
      this.showTime = false
      this.timer = 60
      this.$emit('close')
    },
    submit() {
      if (this.statusCode === 0) {
        //  绑定操作
        this.$refs.forms.validate(valid => {
          if (valid) {
            if (this.type === 'email') {
              let params = {}
              if (!this.isUpdateEmail) {
                params = {
                  content: this.form.email,
                  email: this.form.email,
                  type: 'bindEmail',
                  code: this.form.code
                }
              } else {
                params = {
                  content: this.form.email,
                  email: this.form.email,
                  code: this.form.code,
                  type: 'bindEmail'
                }
              }
              console.log('绑定邮箱', this.isUpdateEmail)
              this.$emit('submitEmail', params, this.isUpdateEmail)
            } else if (this.type === 'phone') {
              let params = {}
              if (!this.isUpdatePhone) {
                // 绑定
                params = {
                  phone: this.form.phone,
                  code: this.form.code,
                  prefix: this.prefix
                }
              } else {
                // 更换
                params = {
                  content: this.form.phone,
                  phone: this.form.phone,
                  code: this.form.code,
                  type: 'bindPhone',
                  prefix: this.prefix
                }
              }
              console.log('绑定手机', this.isUpdatePhone)
              this.$emit('submitPhone', params, this.isUpdatePhone)
            }
          }
        })
      } else {
        // 更新操作
        if (this.activeName === '1') {
          // activeName 1 手机
          this.$refs.phoneForm.validate(valid => {
            if (valid) {
              let params = {
                content: this.results.phone,
                phone: this.results.phone,
                type: 'checkPhone',
                code: this.phoneForm.code,
                deviceType: '2',
                prefix: this.prefix
              }
              comCheckCode(params)
                .then(data => {
                  if (data.code === '00000000') {
                    this.statusCode = 0

                    if (this.type === 'email') {
                      // 修改手机  用邮箱验证  还是要
                      this.$emit('selectType', 'email')
                    } else {
                      this.$emit('selectType', 'phone')
                    }
                    if (this.active === '1') {
                      this.isUpdatePhone = true
                    } else if (this.active === '2') {
                      this.isUpdateEmail = true
                    }
                    // this.isUpdatePhone = true
                    clearInterval(this.interval)
                    this.timer = 60
                    this.showTime = false
                  } else {
                    this.$message.error(data.message)
                  }
                })
                .catch(e => {})
            }
          })
        } else if (this.activeName === '2') {
          // 验证校验码对不对
          this.$refs.emailForm.validate(valid => {
            if (valid) {
              let params = {
                content: this.results.email,
                email: this.results.email,
                type: 'checkEmail',
                code: this.emailForm.code,
                deviceType: '1'
              }

              comCheckCode(params).then(data => {
                if (data.code === '00000000') {
                  this.statusCode = 0

                  if (this.type === 'email') {
                    // 修改手机  用邮箱验证  还是要
                    this.$emit('selectType', 'email')
                  } else {
                    this.$emit('selectType', 'phone')
                  }
                  if (this.active === '1') {
                    this.isUpdatePhone = true
                  } else if (this.active === '2') {
                    this.isUpdateEmail = true
                  }

                  // this.isUpdateEmail = true
                  clearInterval(this.interval)
                  this.timer = 60
                  this.showTime = false
                } else {
                  this.$message.error(data.message)
                }
              })
            }
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/emailAndPhone/src/main.vue